// extracted by mini-css-extract-plugin
module.exports = {"profilePicture":"ProfilePage_profilePicture__2etFB","name":"ProfilePage_name__1_R-p","country":"ProfilePage_country__3S4-6"};